module.exports = __webpack_public_path__ + "img/exclusive_03.4fc27d82.jpg";